import React, { useEffect, useState } from "react";
import EmployeeTimesheets from "./EmployeeTimesheet";
import ManagerTimesheets from "./ManagerTimesheets";
import * as api from "../../constants/api_constants";
import { post } from "helpers/api_helper";
import secureLocalStorage from "react-secure-storage";
import { hasRolePermission } from "helpers/rolebased_helper";
import AdminTimesheets from "./AdminTimeSheet";

function Timesheets() {
  const [isManager, setIsManager] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const employeeId = secureLocalStorage.getItem("employeeId");
  const isAdmin = !parseInt(employeeId);
  const isAccountant = hasRolePermission(7);
  // debugger;

  useEffect(() => {
    const fetchTimesheets = async () => {
      try {
        const response = await post(api.GET_ALL_TIMESHEETS_BY_SEARCH, {
          search: "",
          sortBy: "timesheetCode",
          direction: "ASC",
          timesheetDTO: {
            subscriptionId: 100,
            employeeId: employeeId ? parseInt(employeeId) : null,
          },
        });
        console.log("response", response);
        debugger;
        setIsManager(response?.data?.isManager);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching timesheets:", error);
        setIsLoading(false);
      }
    };
    fetchTimesheets();
  }, []);

  if (isLoading) {
    return null; // Or you could return a loading spinner
  }

  console.log({ isAdmin, isManager, isAccountant });

  return (
    <>
      {isAdmin && isManager ? (
        <AdminTimesheets />
      ) : isAccountant || isAdmin ? (
        <AdminTimesheets />
      ) : isManager ? (
        <ManagerTimesheets />
      ) : (
        <EmployeeTimesheets />
      )}
    </>
  );
}

export default Timesheets;
